// src/pages/AssetTypePage.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";

const AssetTypePage = () => {
  const [form, setForm] = useState({
    name: "",
  });

  const [types, setTypes] = useState([]);
  const [filterText, setFilterText] = useState("");

  // Edit modal state
  const [showEdit, setShowEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
  });

  /* ===========================
     LOAD ASSET TYPES
  ============================ */
  const loadTypes = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/assettype_list", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const d = res.data;
      let arr = [];

      if (Array.isArray(d)) arr = d;
      else if (Array.isArray(d.data)) arr = d.data;
      else if (Array.isArray(d.types)) arr = d.types;

      setTypes(arr || []);
    } catch (err) {
      console.error("Load types error:", err);
      toast.error("Failed to load asset types");
    }
  };

  useEffect(() => {
    loadTypes();
  }, []);

  /* ===========================
     ADD ASSET TYPE
  ============================ */
  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(API_BASE_URL + "/create_assettype", form, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      toast.success("Asset Type added successfully!",{
        position: "bottom-right",
      });

      setForm({ name: "" });
      loadTypes();
    } catch (err) {
  if (err.response?.status === 422 && err.response.data?.errors) {
    Object.values(err.response.data.errors).forEach((msg) =>
      toast.error(msg[0], { position: "bottom-right" })
    );
  } else {
    console.error("Add asset type error:", err);
    toast.error("Error adding asset type", { position: "bottom-right" });
  }
}

  };

  /* ===========================
     DELETE ASSET TYPE
  ============================ */
  const deleteType = async (id) => {
    if (!window.confirm("Delete this asset type?")) return;

    try {
      await axios.delete(API_BASE_URL + `/assettype_delete/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      toast.success("Asset type deleted!");
      loadTypes();
    } catch (err) {
      console.error("Delete asset type error:", err);
      toast.error("Error deleting type");
    }
  };

  /* ===========================
     EDIT ASSET TYPE
  ============================ */
  const openEditModal = async (id) => {
    try {
      const res = await axios.get(API_BASE_URL + `/edit_assettype/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      setEditForm({
        name: res.data.name,
      });
      setEditId(id);
      setShowEdit(true);
    } catch (err) {
      console.error("Load single asset type error:", err);
      toast.error("Error loading asset type");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(API_BASE_URL + `/update_assettype/${editId}`, editForm, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      toast.success("Asset Type updated successfully!",{
        position: "bottom-right",
      });
      setShowEdit(false);
      loadTypes();
    } catch (err) {
  if (err.response?.status === 422 && err.response.data?.errors) {
    Object.values(err.response.data.errors).forEach((msg) =>
      toast.error(msg[0], { position: "bottom-right" })
    );
  } else {
    console.error("Update asset type error:", err);
    toast.error("Update failed", { position: "bottom-right" });
  }
}

  };

  /* ===========================
     DATATABLE COLUMNS
  ============================ */
  const columns = [
    {
      name: "Action",
      width: "140px",
      cell: (row) => (
        <>
        <button
        className="border-0 bg-transparent me-2"
        title="Edit"
        onClick={() => openEditModal(row.id)}
        style={{ cursor: "pointer" }}
      >
        <i className="fa fa-pencil text-warning" style={{ fontSize: "18px" }}></i>
          </button>

          {/* <button
            className="btn btn-danger btn-sm"
            onClick={() => deleteType(row.id)}
          >
            <i className="fa fa-trash" />
          </button> */}
        </>
      ),
    },
    {
      name: "Type Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  const filteredItems = (types || []).filter((item) =>
    (item.name || "").toLowerCase().includes(filterText.toLowerCase())
  );

  /* ===========================
       RENDER UI
  ============================ */
  return (
    <div className="container mt-4">
      <ToastContainer />

      <div className="row">
        {/* LEFT SIDE FORM */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <h6 className="card-header">Add New Asset Type</h6>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3 required-tooltip">
                  <label>Asset Type</label>
                  <input
                    type="text"
                    className="form-control required-input"
                    name="name"
                    value={form.name}
                    onChange={handleInput}
                    placeholder="Enter asset type name"
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  <i className="fa fa-check-square-o"></i> Save
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE TABLE */}
        <div className="col-md-8">
          <div className="card shadow-sm">
            <h6 className="card-header d-flex justify-content-between align-items-center">
              <span>List All Asset Types</span>

              <input
                type="text"
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </h6>

            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredItems}
                pagination
                highlightOnHover
                striped
                persistTableHead
              />
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      {showEdit && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleEditSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Edit Asset Type</h5>
                 <button
    type="button"
    onClick={() => setShowEdit(false)}
    style={{
      background: "transparent",
      border: "none",
      fontSize: "24px",
      fontWeight: "bold",
      cursor: "pointer",
      lineHeight: "1",
    }}
  >
    ×
  </button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Type Name </label>
                    <input
                      type="text"
                      className="form-control required-input"
                      value={editForm.name}
                      onChange={(e) =>
                        setEditForm({ ...editForm, name: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowEdit(false)}
                  >
                    Close
                  </button>
                  
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssetTypePage;
